import DatePicker from "react-datepicker";

const DateSelector = ({ label, placeholder, value, onChange }) => {
  return (
    <>
      <label className="label" htmlFor="">
        {label}
      </label>
      <div className={"filter-dropdown-cross"}>
        <DatePicker
          className="date-picker"
          placeholderText={placeholder || "Select Date"}
          selected={value}
          onChange={(date) => onChange(date)}
        />
      </div>
    </>
  );
};

export default DateSelector;
